var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"mx-4 my-4"},[_c('UpgradeAlert'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }